import { render, staticRenderFns } from "./memberAffiliates.vue?vue&type=template&id=46b1aa54"
import script from "./memberAffiliates.vue?vue&type=script&lang=js"
export * from "./memberAffiliates.vue?vue&type=script&lang=js"
import style0 from "./memberAffiliates.vue?vue&type=style&index=0&id=46b1aa54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports